import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Button, Modal } from 'semantic-ui-react';

// FAMILY-EXT: матрица Эйзенхауэра — модалка-уточнение, когда карточка
// в default-режиме дропнута между соседями из РАЗНЫХ квадрантов. Просим
// пользователя выбрать, в какой именно квадрант отправить карточку.
// Закрытие крестиком/Escape = квадрант не меняется (карточка остаётся
// в своей текущей зоне до явного выбора).
const EisenhowerQuadrantPicker = React.memo(({ pendingPicker, onPick, onCancel }) => {
  const [t] = useTranslation();

  const handlePick = useCallback(
    (quadrant) => () => {
      onPick(pendingPicker.cardId, quadrant);
    },
    [onPick, pendingPicker],
  );

  if (!pendingPicker) return null;

  return (
    <Modal open size="mini" closeIcon onClose={onCancel}>
      <Modal.Header>{t('common.chooseEisenhowerQuadrant')}</Modal.Header>
      <Modal.Content>
        <p>{t('common.cardDroppedBetweenQuadrants')}</p>
      </Modal.Content>
      <Modal.Actions>
        {pendingPicker.options.map((q) => (
          <Button key={q} primary onClick={handlePick(q)}>
            {t(`common.quadrant${q.toUpperCase()}`)}
          </Button>
        ))}
      </Modal.Actions>
    </Modal>
  );
});

EisenhowerQuadrantPicker.propTypes = {
  pendingPicker: PropTypes.shape({
    cardId: PropTypes.string.isRequired,
    options: PropTypes.arrayOf(PropTypes.string).isRequired,
  }),
  onPick: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

EisenhowerQuadrantPicker.defaultProps = {
  pendingPicker: null,
};

export default EisenhowerQuadrantPicker;
